import styled from 'styled-components';

export const HiddenOverflow = styled.div`
  overflow: hidden;
`;

export const LeftDoubleController = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  left: ${(props) => (props.autoHeight ? '-34px' : '-50px')};
  width: 44px;
  height: ${(props) => (props.autoHeight ? 'auto' : '100%')};
  cursor: pointer;
  z-index: 9;
  transition: all 0.3s ease;

  @media (max-width: 720px) {
    left: 6px;
    cursor: default;
    width: 30px;
    height: 30px;
    background: #0000001f;
    border-radius: 50%;
  }

  img {
    width: clamp(18px, 3vw, 30px);
    height: clamp(18px, 3vw, 30px);
    margin: auto;
    transform: rotate(90deg);
  }

  &:hover {
    background-color: #e5e7e7;
  }
`;

export const RightDoubleController = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: ${(props) => (props.autoHeight ? '-34px' : '-50px')};
  width: 44px;
  overflow-x: hidden;
  height: ${(props) => (props.autoHeight ? 'auto' : '100%')};
  cursor: pointer;
  z-index: 9;
  transition: all 0.2s ease;

  @media (max-width: 720px) {
    right: 6px;
    cursor: default;
    width: 30px;
    height: 30px;
    background: #0000001f;
    border-radius: 50%;
  }
  img {
    width: clamp(18px, 3vw, 30px);
    height: clamp(18px, 3vw, 30px);
    margin: auto;
    transform: rotate(270deg);
  }

  &:hover {
    background-color: #e5e7e7;
  }
`;
